import { createSelector } from 'reselect';

import getBreadcrumbIndex from '@/state/selectors/secondary-nav/get-breadcrumb-index';

const isBreadcrumbOpen = createSelector(
	[getBreadcrumbIndex],
	(breadcrumbIndex) =>
		breadcrumbIndex !== null && breadcrumbIndex !== undefined,
);

export default isBreadcrumbOpen;
